import styled from "@emotion/styled";
import {getFont} from "../utils";
import {BaseColor, getBaseColor, FormStyleFn} from "./utils";
import Note from "./Note";

const getColor: FormStyleFn<BaseColor> = (props) => {
  const {theme, crossBrand} = props;
  return getBaseColor(
    !crossBrand && ["br", "on"].includes(theme.brand) ? "bk" : "gray80"
  )(props);
};

const Help = styled(Note)`
  color: ${getColor};
  ${getFont("primary")};
`;

export default Help;
